<template>
    <div class="vue-form-group">
        <div v-for="(option, value) in attributes.options" class="vue-form-group-item">
            <input
                :id="option.id"
                :type="(type === 'toggle' ? 'checkbox' : type)"
                :name="attributes.htmlName"
                :tabindex="context.tabindex"
                :aria-labelledby="`${option.id}-label`"
                :class="['vue-input', 'vue-input-' + type]"
                :checked="isChecked(option)"
                :disabled="option.disabled"
                @click="selectOption(option)"
                v-bind="attributes.attributes">
            <label
                :id="`${option.id}-label`"
                :for="option.id"
                class="vue-form-group-label">
                <span class="toggle" v-if="type === 'toggle'"></span>
                <span :class="['field-label', {'disabled' : option.disabled}]">
                    <span v-html="option.label"/>
                    <span class="field-help" v-if="option.helpText">
                        <span>{{option.helpText}}</span>
                    </span>
                </span>
            </label>
        </div>
    </div>
</template>

<script src="./vue-input-group.js"></script>
